var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c(
        "div",
        [
          _c(
            "v-row",
            { staticClass: "mt-0" },
            [
              _c(
                "v-col",
                [
                  _vm.editable
                    ? _c("v-autocomplete", {
                        attrs: {
                          items: _vm.availableUsers,
                          chips: "",
                          label: "Add Users",
                          "full-width": "",
                          "hide-selected": "",
                          "deletable-chips": "",
                          multiple: "",
                          "single-line": "",
                        },
                        on: { blur: _vm.addUsers },
                        model: {
                          value: _vm.usersToAdd,
                          callback: function ($$v) {
                            _vm.usersToAdd = $$v
                          },
                          expression: "usersToAdd",
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-row",
        [
          _c(
            "v-col",
            [
              _c("v-data-table", {
                attrs: {
                  headers: _vm.displayedHeaders,
                  items: _vm.currentUsers,
                  "items-per-page": 5,
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: `item.full-name`,
                      fn: function ({ item }) {
                        return [
                          _vm._v(
                            " " +
                              _vm._s(item.firstName) +
                              " " +
                              _vm._s(item.lastName) +
                              " "
                          ),
                        ]
                      },
                    },
                    {
                      key: `item.groupRole`,
                      fn: function ({ item }) {
                        return [
                          _vm.editable
                            ? _c("v-select", {
                                attrs: {
                                  value: item.groupRole,
                                  items: ["owner", "member"],
                                },
                                on: {
                                  click: function ($event) {
                                    _vm.editedUserID = item.id
                                  },
                                  change: _vm.onUpdateGroupUserRole,
                                },
                              })
                            : _c("span", [
                                _vm._v(" " + _vm._s(item.groupRole) + " "),
                              ]),
                        ]
                      },
                    },
                    {
                      key: `item.actions`,
                      fn: function ({ item }) {
                        return [
                          _c(
                            "v-icon",
                            {
                              attrs: { small: "", title: "Delete" },
                              on: {
                                click: function ($event) {
                                  return _vm.deleteUserDialog(item)
                                },
                              },
                            },
                            [_vm._v(" mdi-delete ")]
                          ),
                        ]
                      },
                    },
                    {
                      key: "no-data",
                      fn: function () {
                        return [
                          _vm._v(" No users currently added to this group. "),
                        ]
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  true
                ),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("ActionDialog", {
        attrs: { type: "user" },
        on: { cancel: _vm.closeActionDialog, confirm: _vm.deleteUserConfirm },
        model: {
          value: _vm.dialogDelete,
          callback: function ($$v) {
            _vm.dialogDelete = $$v
          },
          expression: "dialogDelete",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }